<template lang="pug">
  form(@submit.prevent="onSearch()")
    div(class="modal-card" style="width: auto")
      header(class="modal-card-head")
        p(class="modal-card-title")
          | 絞り込み条件

      section(class="modal-card-body")
        b-field(label="登録日")
          b-datepicker(
            placeholder="選択してください"
            v-model="formProps.created_on_gteq"
            id="date_from"
          )
          | ~
          b-datepicker(
            placeholder="選択してください"
            v-model="formProps.created_on_lteq"
            id="date_to"
          )

        b-field(label="書籍名(代表)")
          b-input(
            type="text"
            v-model="formProps.book_name_cont"
            id="isbn"
          )

        b-field(label="取次書店コード")
          b-input(
            type="text"
            v-model="formProps.agency_shop_code_cont"
            id="agency_shop_code"
          )
        b-field(label="書店名")
          b-input(
            type="text"
            v-model="formProps.final_book_shop_name_cont"
            id="book_shop_name"
          )
        b-field(label="入力者")
          b-input(
            type="text"
            v-model="formProps.user_name_cont"
            id="user_name"
          )
        b-field(label="未処理のみ")
          b-switch(v-model="formProps.only_unprocessed" id="only_unprocessed" class="switch-relative")
            | {{ onlyUnprocessedText }}
      footer(class="modal-card-foot")
        button(class="button is-info is-fullwidth")
          i.fas.fa-undefine.fa-search.icon-left
          | この条件で検索
        button(class="button" type="button" @click="$parent.close()")
          i.fas.fa-times
</template>

<script>
  export default {
    name: "serach-kakuzai-modal",
    props: ['formProps'],
    computed: {
      onlyUnprocessedText(){
        return this.formProps.only_unprocessed ? '未処理のみを表示する' : 'すべての拡材を表示する'
      }
    },
    methods: {
      onSearch(){
        this.$emit('update:formProps', this.formProps)
        this.$emit('on-search')
        this.$parent.close()
      }
    }
  }
</script>
